import React from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
} from '@material-ui/core';

import Alert from '../../common/components/Alert';
import JoinEventForm from './JoinEventForm';

import classes from '../../css/getCSS';


const joinEventDialog = (props) => {
  let form = null;
  if (props.formEnabled && !props.actionLoading) {
    form = (
      <JoinEventForm
        inputs={props.eventForm}
        inputChangedHandler={props.inputChangedHandler}
      />
    );
  }

  let loading = null;
  if (props.actionLoading) {
    loading = (
      <div align="center">
        <CircularProgress align="center" size={50} /> <br />
        <Typography variant="body1">Loading. Please wait</Typography>
      </div>
    );
  }

  let errorAlert = null;
  if (props.actionError) {
    errorAlert = <Alert type="danger">{props.actionError}</Alert>;
  }

  let success = null;
  if (props.eventJoined) {
    success = (
      <Typography align="center" variant="subheading">
        Interest Sent! You can close this dialog now.
      </Typography>
    );
  }

  let confirmButton = null;
  if (props.confirmVisible) {
    confirmButton = (
      <Button type="submit" color="primary">
        Join
      </Button>
    );
  }

  return (
    <Dialog
      fullWidth
      open={props.open}
      onClose={props.close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      classes={{
        paper: classes.reqDialogCard,
        root: classes.reqDialogRoot,
      }}
    >
      <DialogTitle id="alert-dialog-title">Join this event</DialogTitle>
      <form method="post" onSubmit={props.submitHandler}>
        <DialogContent classes={{ root: classes.reqDialogContent }}>
          <DialogContentText>
            You are about to register for an event! <br />
            You will get a confirmation mail for the same. <br />
            Please note that registering and not showing up on the event&nbsp;
            will result in account deactivation. <br />
          </DialogContentText>
          <br />
          {loading}
          {errorAlert}
          {success}
          {form}
        </DialogContent>
        <DialogActions>
          <Button onClick={props.close} color="primary">
            Cancel
          </Button>
          {confirmButton}
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default joinEventDialog;



// WEBPACK FOOTER //
// ./src/main/components/JoinEventDialog.js